import { Spin } from 'antd';

import { AutoInventoryStepsModern } from 'app/typings/autoInventory';

import { ConfigStep } from '../ConfigStep/ConfigStep';

import styles from './RoomMapping.module.scss';
import { RoomMappingRow } from './RoomMappingRow';
import { useRoomMapping } from './useRoomMapping';

type RoomMappingProps = {
  handleStepChange: (step: AutoInventoryStepsModern) => void;
  onDeactivate?: () => void;
  isDisabling?: boolean;
};

export const RoomMapping = ({
  handleStepChange,
  onDeactivate,
  isDisabling,
}: RoomMappingProps) => {
  const { rooms, bookingRooms, isLoading, isOptionDisabled } = useRoomMapping();

  return (
    <ConfigStep
      step={AutoInventoryStepsModern['room-mapping']}
      className={styles.roomMapping}
      handleStepChange={handleStepChange}
      onDeactivate={onDeactivate}
      isDisabling={isDisabling}
    >
      <p className={styles.explanation}>
        First, link your existing Staycation room categories to Booking.com room
        categories.
      </p>

      <div className={styles.mappingContainer}>
        <div className={styles.columnHeaders}>
          <div className={styles.staycationRooms}>Staycation rooms</div>
          <div className={styles.divider}></div>
          <div className={styles.bookingRooms}>Booking.com rooms</div>
        </div>

        <Spin spinning={isLoading}>
          <div className={styles.roomRows}>
            {rooms.map((room, idx) => (
              <RoomMappingRow
                key={room.id}
                room={room}
                roomIdx={idx}
                bookingRooms={bookingRooms}
                isOptionDisabled={isOptionDisabled}
              />
            ))}
          </div>
        </Spin>
      </div>
    </ConfigStep>
  );
};
